module.exports = __webpack_public_path__ + "img/2_en.acff756.png";